module.exports = __webpack_public_path__ + "img/DeepeningCardScreenshot-1250h.b799ec5b.png";